module.exports = __webpack_public_path__ + "img/813920.ccd93c05.jpg";